export type EntityCode = 'LHK' | 'LMA' | 'EHK' | 'GHK' | 'G4HK';
export type Lang = 'en' | 'zh';

export enum FeatureName {
  UpdateAddress = 'updateAddress',
  UpdateEmail = 'updateEmail',
  UpdateMobile = 'updateMobile',
}

export interface PolicyInfo {
  policyNumber: string;
  policyName: PolicyName;
  certificateNumber: string;
  dependentNumber: string;
  entityCode: EntityCode;
  eCommEligible: 'Y' | 'N';
  suspensionFlagEmail: 'S' | string;
  suspensionFlagSms: 'S' | string;
}

interface PolicyName {
  en: string;
  zh: string;
}
